<div class="step-container">
  <h2 class="step-title">Confirme sus datos</h2>
  <p class="step-subtitle">Verifique que los datos extraídos de su DNI sean correctos.</p>

  <div class="data-card" *ngIf="identityData">
    <div class="data-row">
      <span class="data-label">Nombre</span>
      <span class="data-value">{{ identityData.name }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Apellido</span>
      <span class="data-value">{{ identityData.lastName }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">Género</span>
      <span class="data-value">{{ identityData.gender === 'M' ? 'Masculino' : identityData.gender === 'F' ? 'Femenino' : 'Autopercibido' }}</span>
    </div>
    <div class="data-row">
      <span class="data-label">CUIL</span>
      <span class="data-value">{{ identityData.cuil }}</span>
    </div>
  </div>

  <button
    mat-raised-button
    color="primary"
    class="action-button"
    (click)="onConfirm()">
    Confirmar datos
  </button>
</div>
